export default "__VITE_ASSET__860f9a51__"